import { ScrollArea } from "@/components/ui/scroll-area";
import { SectionHeader, FaqItem } from './shared';
import { FAQType } from './types';

// FAQ data
const faqs: FAQType[] = [
    {
        question: "How does the BerryBabies smart diaper sensor work?",
        answer: "Our sensor attaches to any standard diaper and uses advanced moisture detection technology to monitor your baby's wetness levels. When a change is needed, you'll receive an instant notification through our mobile app."
    },
    {
        question: "Is the sensor safe for my baby's skin?",
        answer: "Absolutely! Our sensors are made with medical-grade, hypoallergenic materials that have been extensively tested and are safe for even the most sensitive skin. The sensor is small, lightweight, and designed to be unnoticeable to your baby."
    },
    {
        question: "How long does the battery last?",
        answer: "Our smart sensors feature an industry-leading battery life of up to 6 months under normal use conditions. The app will notify you well in advance when the battery is running low."
    },
    {
        question: "Can I reuse the sensor with multiple diapers?",
        answer: "Yes! The BerryBabies sensor is designed to be easily transferred between diapers. Simply detach it from a used diaper and attach it to a fresh one - it takes just seconds."
    },
    {
        question: "What kind of health insights will I receive?",
        answer: "Our app provides detailed analytics about your baby's diaper change frequency, wetness patterns, and estimated hydration levels. This information can help identify potential health concerns early and establish healthy routines."
    }
];

export const FAQ = () => {
    return (
        <section className="container mx-auto px-4 py-16">
            <SectionHeader 
                badgeText="Common Questions"
                badgeClasses="bg-gradient-to-r from-blue-500/20 to-sky-500/20 text-blue-600 dark:text-blue-400 hover:from-blue-500/30 hover:to-sky-500/30"
                title="Frequently Asked Questions"
                description="Everything you need to know about our smart diaper technology"
            />
            
            <div className="max-w-3xl mx-auto">
                <ScrollArea className="h-[450px] rounded-xl shadow-lg border border-primary/10 p-8 bg-white">
                    <div className="pr-6">
                        {faqs.map((faq, index) => (
                            <FaqItem key={index} faq={faq} />
                        ))}
                    </div>
                </ScrollArea>
            </div>
        </section>
    );
};